import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import { getEnvVariable } from '../../../../modules/environmentalList';
import { AdminList } from '../../../../json/administration/adminlist';
import { ExternalList } from '../../../../json/administration/externallist';
import { NotAdminRegList } from '../../../../json/administration/notadminreglist';
import { NotRegList } from '../../../../json/administration/noregistrationlist';
import { SuperAdminList } from '../../../../json/administration/superadminlist';
import { getSignInToken } from '../../header';
import { PreparerExternalList } from '../../../../json/administration/preparerexternallist';
import { SystemAdminList } from '../../../../json/administration/Systemadminlist';
import ExternalMain from './externalmain';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

const generateTabPanels = (printlist, value) => {
    const tabKeys = Object.keys(printlist);
    return tabKeys.map((key, index) => (
        <TabPanel className="col-sm-12 p-1" value={value} index={index} key={index}>
            <Grid container spacing={2} className="ames-tabpanel">
                {(printlist[key] || []).map(e => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={e.title}>
                        <a target={e.target && e.target === "blank" ? "_blank" : "_self"} rel={e.target && e.target === "blank" ? "noreferrer" : undefined} href={e.target && e.target === "blank" ? e.link : '#' + e.link}>
                            <Paper href={e.link} elevation={4} className="p-2" style={{ textAlign: 'center' }}>
                                <Icon style={e.style || { color: e.color, fontSize: '3rem' }} className='dashboard-icons'>{e.materialicon}</Icon>
                                <Typography component="h5" variant="h6" className='text-center' style={{ marginTop: '10px' }}>
                                    {e.title}
                                </Typography>
                            </Paper>
                        </a>
                    </Grid>
                ))}
            </Grid>
        </TabPanel>
    ));
};

export default function PaperSheet(props) {
    let permissions = props.accessPermissions;
    const [displaySettingsTabList, setDisplaySettingsTabList] =
        React.useState(props.AccessPortal === 'I' ? (
            permissions.isSystemAdmin === 'Y' ? true :
                permissions.isSuperAdmin === 'Y' ? true :
                    permissions.isAdmin === 'Y' ? true :
                        permissions.isRequestAdmin === 'Y' ? false :
                            false) : false
        );

    let printlist =
        (props.AccessPortal === 'I' ? (
            permissions.isSystemAdmin === 'Y' ? SystemAdminList[getEnvVariable('ModuleKey')] :
                permissions.isSuperAdmin === 'Y' ? SuperAdminList[getEnvVariable('ModuleKey')] :
                    permissions.isAdmin === 'Y' ? AdminList[getEnvVariable('ModuleKey')] :
                        permissions.isRequestAdmin === 'Y' ? NotRegList[getEnvVariable('ModuleKey')] :
                            permissions && permissions.roles.length === 1 && Object.keys(permissions.roles).some(each => permissions.roles[each] === 'User') ?
                                NotAdminRegList[getEnvVariable('ModuleKey')] :
                                permissions && permissions.roles && permissions.roles.includes("Official") && permissions.companyAccessId ?
                                    ExternalList[getEnvVariable('ModuleKey')] : PreparerExternalList[getEnvVariable('ModuleKey')]) :
            NotAdminRegList[getEnvVariable('ModuleKey')]);

    if (printlist && printlist.myportallist && localStorage.getItem('submodule')) {
        ((printlist && printlist.myportallist) || []).map((e, index) => {
            if (e.title === 'Records') {
                let submodule = JSON.parse(localStorage.getItem('submodule'));
                printlist.myportallist.splice(index, 1, ...submodule);
            }
        });
    }

    const hideAdminTab = () => {
        return (permissions.isSystemAdmin === 'Y' ? true :
            permissions.isSuperAdmin === 'Y' ? true :
                permissions.isAdmin === 'Y' ? true :
                    permissions.isRequestAdmin === 'Y' ? true :
                        false);
    };

    if (!getSignInToken()) {
        window.location.reload(true);
    }

    const [value, setValue] = React.useState((localStorage.getItem('tab') === 'D' ? 0 : parseInt(localStorage.getItem('tab'))) || 0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [mainvalue, setMainValue] = React.useState(0);

    const handleMainChange = (event, newValue) => {
        setMainValue(newValue);
    };

    return (
        <div className="pt-2 ames-tab-dashboard">
            <Tabs
                value={mainvalue}
                onChange={handleMainChange}
                indicatorColor="primary"
                textColor="primary"
                aria-label="icon label tabs example"
                centered
            >
                <Tab label={'About'} style={{ fontWeight: 'bold', fontSize: '1rem', padding: 0 }} />
                <Tab label={'Main Menu'} style={{ fontWeight: 'bold', fontSize: '1rem', padding: 0 }} />
            </Tabs>
            <TabPanel value={mainvalue} index={0}>
                <ExternalMain />
            </TabPanel>
            <TabPanel value={mainvalue} index={1}>
                <Grid container spacing={2}>
                    <Grid item xs={2}>
                        <Tabs
                            value={value}
                            orientation='vertical'
                            onChange={handleChange}
                            variant="fullWidth"
                            indicatorColor="primary"
                            textColor="primary"
                            aria-label="icon label tabs example"
                            style={{ marginBottom: '20px' }}
                        >
                            <Tab label={<Paper elevation={3} style={{ borderRadius: '5px', padding: 10, width: '100%' }}>
                                Dashboard
                            </Paper>} />
                            <Tab label={<Paper elevation={3} style={{ borderRadius: '5px', padding: 10, width: '100%' }}>
                                My Portal
                            </Paper>} />
                            <Tab label={<Paper elevation={3} style={{ borderRadius: '5px', padding: 10, width: '100%' }}>
                                {props.AccessPortal !== 'E' ? "Public Hub" : "Portal Management"}
                            </Paper>} />
                            {props.AccessPortal !== 'E' && hideAdminTab() && (
                                <Tab label={<Paper elevation={3} style={{ borderRadius: '5px', padding: 10, width: '100%' }}>
                                    Administration
                                </Paper>} />
                            )}
                            {props.AccessPortal !== 'E' && displaySettingsTabList && (
                                <Tab label={<Paper elevation={3} style={{ borderRadius: '5px', padding: 10, width: '100%' }}>
                                    Master Settings
                                </Paper>} />
                            )}
                            {props.AccessPortal !== 'E' && displaySettingsTabList && (
                                <Tab label={<Paper elevation={3} style={{ borderRadius: '5px', padding: 10, width: '100%' }}>
                                    Site Settings
                                </Paper>} />
                            )}
                        </Tabs>
                    </Grid>
                    <Grid item xs={10}>
                        {generateTabPanels(printlist, value)}
                    </Grid>
                </Grid>
            </TabPanel>
        </div>
    );
}